/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Temperature_Average_ComfortInputs */



/**
* | output |
* | --- |
* | "Average comfort temperature" |
*
* @param {Temperature_Average_ComfortInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const temperature_average_comfort = /** @type {((inputs?: Temperature_Average_ComfortInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Temperature_Average_ComfortInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average comfort temperature")
	return /** @type {LocalizedString} */ ("Température moyenne de confort")
});